const SCORES = {
    MODEL_ID: 200,
    TOP_SALES: 100,
    RECOMMENDED: 80,
    PRODUCT_OF_THE_WEEK: 80,
    SPONSORED: 75,
};

export const getMerchandizingBooster = ({
    hasAlternateEngine = false,
    modelId,
    categoryId,
}) => {
    // ABTesting REC-1654
    const engineType = hasAlternateEngine ? 'banner.alternate' : 'banner';

    const merchandizingBooster = [];

    if (!categoryId) return merchandizingBooster;

    merchandizingBooster.push(
        `${engineType}.categories: topSales.${categoryId}<score=${SCORES.TOP_SALES}>`,
    );
    merchandizingBooster.push(
        `${engineType}.categories: recommended.${categoryId}<score=${SCORES.RECOMMENDED}>`,
    );
    merchandizingBooster.push(
        `${engineType}.categories: productOfTheWeek.${categoryId}<score=${SCORES.PRODUCT_OF_THE_WEEK}>`,
    );
    if (modelId)
        merchandizingBooster.push(
            `model_id: ${modelId}<score=${SCORES.MODEL_ID}>`,
        );
    return merchandizingBooster;
};

export const getSponsoredProductsBooster = ({
    adsInfo = [],
    hasSponsoredProducts = false,
}) => {
    if (hasSponsoredProducts) {
        return adsInfo.map(
            ({ product_id: productId }, index) =>
                `objectID: ${productId}<score=${SCORES.SPONSORED - index}>`,
        );
    }

    return [];
};

export default {
    getMerchandizingBooster,
    getSponsoredProductsBooster,
};
